module.exports = __webpack_public_path__ + "assets/media/day11.a77083c7.mp3";